import { useTheme } from './useTheme';
import type { Template } from './types';

/**
 * Convenience hook returning just the active `template` from the current
 * ThemeProvider — equivalent to `useTheme().template`.
 */
export function useTemplate(): Template {
  return useTheme().template;
}
